import { TranslateResult } from 'vue-i18n';

import { getApp } from '@/main';
import { isMobile } from '@/mobile';

function notify( message: TranslateResult, variant: string = 'default' ) {
	message = message.toString();
	if ( !message ) {
		return;
	}
	const toastClass = `notification-toast notification-toast-${variant || ''}`;
	getApp().$bvToast.toast( message, {
		variant: variant,
		autoHideDelay: message.length > 30 ? 5500 : 2000,
		noCloseButton: true,
		toastClass: toastClass,
		toaster: isMobile() ? 'b-toaster-bottom-center' : 'b-toaster-top-center',
		solid: true
	} );
}

export default {
	info( message: TranslateResult ) {
		notify( message, 'info' );
	},
	success( message: TranslateResult ) {
		notify( message, 'success' );
	},
	warning( message: TranslateResult ) {
		notify( message, 'warning' );
	},
	error( error?: unknown ) {
		if ( error instanceof Error ) {
			error = error.message;
		}
		if ( typeof error === 'string' ) {
			notify( getApp().$t( 'common.error-message', { error } ), 'error' );
		} else {
			notify( getApp().$t( 'common.error' ), 'error' );
		}
	}
};
